import {useEffect,useMemo,useRef,useSyncExternalStore} from 'react';
import {createMoveClient,moveAccountKey,type MoveClient} from '../client';
import {createDraft} from '../../browser-recovery/drafts';
import {emptyMoveDraft,validMoveDraft} from '../draft';
import type {MoveAccount} from '../types';
const clients=new Map<string,MoveClient>();
if(typeof window!=='undefined'){
 window.addEventListener('storage',()=>clients.forEach(c=>c.refreshSaved()));
 window.addEventListener('beforeunload',e=>{if([...clients.values()].some(c=>c.snapshot().pending)){e.preventDefault();e.returnValue='';}});
}
export function useMoveClient(base:string,account:MoveAccount,begin?:()=>()=>void){
 const key=moveAccountKey(base,account),live=useRef(key);live.current=key;
 useEffect(()=>{live.current=key;return()=>{live.current='';};},[key]);
 if(!clients.has(key))clients.set(key,createMoveClient(base,account,begin));
 const client=clients.get(key)!;client.activate(()=>live.current===key);
 const state=useSyncExternalStore(client.subscribe,client.snapshot);
 return {client,key,...state,locked:state.busy||!!state.pending||state.blocked};
}
export function useMoveDraft(key:string){
 const store=useMemo(()=>createDraft(key,'bin-move-v1',emptyMoveDraft(),validMoveDraft),[key]);
 const state=useSyncExternalStore(store.subscribe,store.snapshot);
 return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};
}
